document.addEventListener('DOMContentLoaded', () => {

	const observer = new MutationObserver(() => {

		const title = [...document.querySelectorAll(
			'.wc-block-components-checkout-step__title'
		)].find(el =>
			el.textContent.trim().includes('Shipping options')
		);

		if (!title || document.querySelector('.my-shipping-note')) {
			return;
		}

		const note = document.createElement('motion.div');

		note.className = 'my-shipping-note';

		note.innerHTML = `
			<div class="message margin-top-1">
				<p class="margin-0">Next day delivery is available for orders placed <strong>before 2pm</strong>, orders placed after this time will be processed the following business day.</p>
			</div>
		`;

		title.insertAdjacentElement('afterend', note);
	});

	observer.observe(document.body, {
		childList: true,
		subtree: true
	});
});